import { render, staticRenderFns } from "./NpcQueryContent.vue?vue&type=template&id=033accf0&scoped=true"
import script from "./NpcQueryContent.vue?vue&type=script&lang=js"
export * from "./NpcQueryContent.vue?vue&type=script&lang=js"
import style0 from "./NpcQueryContent.vue?vue&type=style&index=0&id=033accf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033accf0",
  null
  
)

export default component.exports